<template>
  <div>
    <!-- 卡片试图 -->
    <el-card class="box-card" v-loading="loading">
      <!-- 用户列表区域 -->
      <el-table
        :data="tableData"
        stripe
        class="table"
        ref="table"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column
          :label="$t('channelList.label.channelName')"
          prop="channelName"
        ></el-table-column>
        <el-table-column :label="$t('channelList.label.api')" prop="apiName"></el-table-column>
        <el-table-column :label="$t('channelList.label.status')" prop="openStatus">
          <template slot-scope="{ row }">
            <el-switch
              style="display: block"
              v-model="row.openStatus"
              :active-value="1"
              :inactive-value="0"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-text="$t('channelList.status.open')"
              :inactive-text="$t('channelList.status.close')"
              @change="(val) => handleChangeStatus(row, 'status', val)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('channelList.label.attribute3')"
          prop="attribute3"
        ></el-table-column>
        <el-table-column :label="$t('channelList.label.attribute4')" prop="attribute4">
          <template slot-scope="{ row }">
            <el-input
              v-model="row.attribute4"
              size="small"
              style="width: 50px; text-align: center"
              @input="handleInput"
            />
            %
            <el-button
              type="primary"
              size="mini"
              @click="handleChangeStatus(row,'attribute4')"
            >{{$t('sysConfig.update')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import merchantApi from '@/api/merchant';
import channel from '../../api/channel';

export default {
  name: 'ChannelSetting',
  data() {
    return {
      loading: false,
      tableData: [],
      openStatus: '',
      attribute4: ''
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    formatParams() {
      const _form = Object.keys(this.addClient).reduce((acc, key) => {
        if (!this.isAdd && ['payPass', 'userPass'].indexOf(key) > -1) {
          /**
           * 如果格式化参数为update ，则干掉passwd相关字段
           */
          return acc;
        }
        if (this.addClient[key] === 0 || this.addClient[key]) {
          acc[key] = this.addClient[key];
        }
        return acc;
      }, {});
      return {
        ..._form,
        roleId: this.roleId,
        merchantChannelIds: this.checkedChannels.length > 0 ? this.checkedChannels.join(',') : ''
      };
    },
    // 获取数据列表
    async getTableList() {
      const { data } = await channel.getThirdChannelList({ no: 1, size: 100, query: {} });
      if (data && +data.code === 200) {
        this.tableData = data.data.list;
      } else {
        this.$message.error(this.$t('status.error'));
      }
    },
    // 更新状态
    async handleChangeStatus(row, type, val = '') {
      const params =
        type === 'status' ? { openStatus: Number(val) } : { attribute4: this.attribute4 };
      const { data } = await channel.updateThirdChannelList({ id: row.id, ...params });
      if (data && +data.code === 200) {
        this.$message.success(data.message);
        this.getTableList();
      } else {
        this.$message.error(this.$t('status.error'));
        this.getTableList();
      }
      this.attribute4 = '';
    },
    handleInput(val) {
      this.attribute4 = val;
    },
  }
};
</script>

<style scoped>
.box-card,
.table,
.pag {
  margin-top: 20px;
}

.el-col .el-button:nth-child(1),
.el-col .el-button:nth-child(2) {
  padding: 10px 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/channelSetting/index.vue